export default __webpack_public_path__ + "static/media/responsibility.72d8540b.jpg";